import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const PricingFAQ = () => {
  const faqs = [
    {
      question: "What happens when I exceed my user limit?",
      answer: "You can easily upgrade your plan or add additional user seats at any time. We'll notify you when you're approaching your limit, and there's no service interruption during the upgrade process."
    },
    {
      question: "Can I switch plans anytime?",
      answer: "Yes! You can upgrade or downgrade your plan at any time. When upgrading, you'll have immediate access to new features. When downgrading, changes take effect at the end of your current billing period."
    },
    {
      question: "Are there any setup fees or hidden costs?",
      answer: "No hidden fees whatsoever. The price you see is what you pay. Setup is completely free, and we provide full onboarding support to get your team up and running quickly."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, Mastercard, American Express), bank transfers, and SEPA direct debit for European customers. Enterprise customers can also arrange invoice-based billing."
    },
    {
      question: "Is there a discount for annual billing?",
      answer: "Yes! Save 20% when you choose annual billing. For example, the Professional plan drops from €30/user/month to €24/user/month when billed annually."
    },
    {
      question: "Can I try before I buy?",
      answer: "Absolutely! We offer a full-featured 14-day free trial with no credit card required. You'll have access to all features of your chosen plan to ensure it meets your needs."
    },
    {
      question: "What kind of support is included?",
      answer: "Essential plans include email support with 48-hour response time. Professional plans get priority support with 24-hour response. Enterprise and Custom plans include dedicated account managers and phone support."
    },
    {
      question: "Is my data secure and GDPR compliant?",
      answer: "Yes, security is our top priority. We are fully GDPR compliant, use enterprise-grade encryption, and perform regular security audits. Your data is stored in secure European data centers."
    },
    {
      question: "Can I customize the modules I need?",
      answer: "While our tiered plans include specific modules, Enterprise and Custom plans offer full flexibility. Contact our sales team to discuss a tailored solution with exactly the modules you need."
    },
    {
      question: "What happens to my data if I cancel?",
      answer: "You own your data, always. Before cancellation, you can export all your data in standard formats. We retain your data for 30 days after cancellation in case you change your mind, then it's permanently deleted."
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about our pricing
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border rounded-lg px-6 bg-card shadow-crisp hover:shadow-enhanced transition-shadow"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
